export enum FaqFieldsNames {
  QUESTION = 'question',
  ANSWER = 'answer',
}

export type TFaqFormValues = {
  [FaqFieldsNames.QUESTION]: string;
  [FaqFieldsNames.ANSWER]: string;
};

export enum FaqImportFieldsNames {
  FILE = 'file',
}

export type TFaqImportFormValues = {
  [FaqImportFieldsNames.FILE]: File;
};
